import React, { useEffect, useState } from "react";
import {
  Controller,
  FieldError,
  SubmitHandler,
  useForm,
} from "react-hook-form";
import toast from "react-hot-toast";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useNavigate, useParams } from "react-router-dom";
import { CourseClassInterface } from "../../api/types/types";
import { useCourseClass } from "../../api/useProducts/useCourses";
import {
  CustomButton,
  FileUploadIcon,
  FileUploadModal,
  InputField,
  Sidebar,
} from "../../components";
import useSingleFileUpload from "../../hook/useSingleFileUpload";
import CustomBreadcrumb from "../../components/CustomBreadcrumb";

// Form data interface
interface WorkoutFormData {
  title?: string;
  description?: string;
  order?: number;
  file?: UploadedData;
}
interface UploadedData {
  url?: string;
  file?: File | null;
}
const MoreAddCourseClass: React.FC = () => {
  const { courseId } = useParams();
  const { mutate, isPending } = useCourseClass(Number(courseId));
  const { uploadImage, isUploading } = useSingleFileUpload();
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    reset,
    watch,
    setError,
    clearErrors,
    formState: { errors },
    control,
  } = useForm<WorkoutFormData>();
  const [modalOpen, setModalOpen] = useState<boolean>(false);

  const [uploadedData, setUploadedData] = useState<UploadedData>({});
  console.log("🚀 ~ uploadedData:", uploadedData);
  const handleFileUpload = (data: UploadedData) => {
    setUploadedData(data);
    console.log("Uploaded Data:", data);
  };
  const description = watch("description");

  const handleSave: SubmitHandler<WorkoutFormData> = async (data) => {
    // console.log("Form Submitted", data);
    let hasError = false;
    if (description === "<p><br></p>") {
      setError("description", {
        type: "manual",
        message: "description is required",
      });
      hasError = true;
    }
    // if (!uploadedData.file && !uploadedData.url) {
    //   setError("file", {
    //     type: "manual",
    //     message: "A Video or a URL is required",
    //   });
    //   hasError = true;
    // }
    if (!hasError) {
      // @ts-ignore
      try {
        let imageUrl = null;
        if (uploadedData.file) {
          imageUrl = await uploadImage(uploadedData.file);
        } else {
          imageUrl = uploadedData.url;
        }
        const payload = [
          {
            title: data?.title || "",
            order: Number(data.order) || 0,
            description: data.description || "",
            media: imageUrl || "",
          },
        ];

        mutate(payload as unknown as CourseClassInterface, {
          onSuccess: (data) => {
            toast.success("Successfully created");
            reset();

            navigate(-1);
          },
          onError: (error: any) => {
            toast.error(error.response.data.message);
          },
        });
      } catch (error) {
        toast.error(
          "An error occurred while uploading images or processing data."
        );
      }
    }
  };

  useEffect(() => {
    if (description === "<p><br></p>") {
      console.log("1");
      setError("description", {
        type: "manual",
        message: "description is required",
      });
    } else {
      console.log("2");
      clearErrors("description");
    }
  }, [description]);
  // useEffect(() => {
  //   if (uploadedData) {
  //     clearErrors("file");
  //   }
  // }, [uploadedData]);
  const breadcrumbItems = [
    { title: "Courses", link: "courses" },
    { title: "Add Class " },
  ];
  return (
    <Sidebar>
      <div className="mt-3">
        <CustomBreadcrumb items={breadcrumbItems} />
      </div>
      <div className="flex justify-between items-center my-2">
        <h1 className="font-medium mt- mb-4 text-2xl">Course Class</h1>
      </div>
      <form onSubmit={handleSubmit(handleSave)}>
        <div>
          <div className="grid lg:grid-cols-2 grid-cols-1 gap-3 ">
            <InputField
              label="Title"
              placeholder="Enter title"
              type="text"
              register={register(`title`, {
                required: "title are required",
              })}
              error={errors.title?.message}
            />

            <InputField
              label="order"
              placeholder="Enter order"
              type="number"
              register={register(`order`, {
                required: "Order is required",
                validate: (value) => {
                  // @ts-ignore
                  if (value <= 0) {
                    return "Order must be a positive number";
                  }
                  // @ts-ignore
                  if (!Number.isInteger(parseFloat(value))) {
                    return "Order must be a whole number";
                  }
                  return true;
                },
              })}
              error={errors.order?.message}
            />

            <div className=" mt-2">
              <p className="block text-gray-700 mb-2">Description</p>
              <Controller
                name="description"
                control={control}
                rules={{ required: "description is required" }}
                render={({ field }) => (
                  <ReactQuill
                    {...field}
                    // onChange={(value) => {
                    //   field.onChange(value);
                    // }}
                    className="quill-editor"
                    modules={{
                      toolbar: [
                        ["bold", "italic", "underline", "strike"],
                        ["blockquote", "code-block"],
                        [{ header: 1 }, { header: 2 }],
                        [{ list: "ordered" }, { list: "bullet" }],

                        [{ size: ["small", false, "large", "huge"] }],
                        [{ header: [1, 2, 3, 4, 5, 6, false] }],
                        [{ color: [] }, { background: [] }],

                        [{ align: [] }],
                        ["clean"],
                      ],
                    }}
                  />
                )}
              />
              {errors.description && (
                <p className="text-red-500 text-sm mt-1">
                  {errors.description.message}
                </p>
              )}
            </div>
            <div>
              <p className="block text-gray-700 mt-2">Upload video</p>

              <div className="mt-3">
                <div onClick={() => setModalOpen(true)}>
                  <div
                    role="button"
                    className="flex flex-col justify-center items-center min-h-52 border-[1.5px] border-dashed border-gray-400 rounded-2xl"
                  >
                    {uploadedData.url ? (
                      // Display uploaded URL if present
                      <p className="text-center text-sm text-gray-600">
                        Uploaded URL: {uploadedData.url}
                      </p>
                    ) : uploadedData.file ? (
                      // Display uploaded file if present
                      <p className="text-center text-sm text-gray-600">
                        Uploaded File: {uploadedData.file.name}
                      </p>
                    ) : (
                      // Display upload prompt if nothing is uploaded
                      <>
                        <FileUploadIcon />
                        <CustomButton btntext="Upload" addclass="mt-3" />
                      </>
                    )}
                  </div>
                </div>
              </div>
              {errors.file && (
                <p className="text-red-500 text-sm mt-1">
                  {(errors.file as FieldError)?.message}
                </p>
              )}
            </div>
          </div>
        </div>

        <CustomButton
          type="submit"
          isLoading={isPending || isUploading}
          btntext="Save"
          addclass="mt-5 mx-auto w-1/2"
        />
      </form>
      <FileUploadModal
        modalOpen={modalOpen}
        setModalOpen={setModalOpen}
        onFileUpload={handleFileUpload}
      />{" "}
    </Sidebar>
  );
};

export default MoreAddCourseClass;
